import { authService } from '@/services/api-services';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { QueryKeyTypes } from './queryKeys';

type AcceptTermsOfServicePayload = {
  userId: string;
  tenantId: string;
};

type MutationAcceptTermsOfService = UseMutationOptions<
  unknown,
  Error,
  AcceptTermsOfServicePayload,
  QueryKeyTypes
>;

export const useAcceptTermsOfServiceMutation = (
  options: MutationAcceptTermsOfService = {},
) => {
  const { onSuccess, ...rest } = options;

  const mutation = useMutation({
    mutationFn: authService.setAcceptTermsOfService,
    onSuccess: (data, payload, context) => {
      onSuccess?.(data, payload, context);
    },
    ...rest,
  });

  return mutation;
};
